import { render, staticRenderFns } from "./tc-player.vue?vue&type=template&id=7ba86a58&scoped=true&"
import script from "./tc-player.vue?vue&type=script&lang=js&"
export * from "./tc-player.vue?vue&type=script&lang=js&"
import style0 from "./tc-player.vue?vue&type=style&index=0&id=7ba86a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba86a58",
  null
  
)

export default component.exports